<template>
  <div class="layout layout--default">
    <Nav></Nav>
    <div class="site-content site-content--application">
      <Messages />
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/Navigation/Navigation.vue'
import Messages from '@/components/_shared/Messages/Messages.vue'

export default {
  name: 'DefaultLayout',

  components: {
    Nav,
    Messages,
  },
}
</script>
